export default {
    methods: {
        addTopsInstallationAndVersionPrefix: function (stringValue) {
            if (this.$config.installationAndVersionPrefix) return this.$config.installationAndVersionPrefix + "_" + stringValue;
            return stringValue;
        }
    }
}